export default __webpack_public_path__ + "static/media/add_jobs.81d2ede5.svg";